import merge from 'lodash/merge'

import en from '@shared/i18n/locales/en'

export default merge(en, {
  pt: {
    payment: {
      title: 'Payment processor',
    },

    timeUnits: {
      min: 'min',
    },

    tracker: {
      _: 'Tracking',
      log: 'Log yourself',
      intro:
        "Welcome to the tracker. You can visit this any time by tapping on the tracker button, and from here you can keep track of yourself and see any past data that you've entered.",
      columns: {
        time: 'Created at',
      },
      sign: {
        signed: 'Signed',
      },
      resultText: 'Thanks for submission!',
      resultAgain: 'Log again',
    },

    help: {
      _: 'Help',
      title: 'If you have an emergency, call 911 at once.',
      newConversation: 'New conversation',
      startOver: 'Start Over',
      seeAllConversations: 'See the list of all conversations',
      speakToHuman: 'Speak to Human',
    },

    messages: {
      finishVideoChatWarning: 'Do you want to end the Video Chat?',
      errors: {
        feiledSendMessage:
          'Failed to send the message. Please try again later. Details: {error}',
        auth: 'Authentification failed. A link is incorrect or it has expired',
        authIncorrect: 'That was incorrect.',
        authTryAgain: 'Please try again.',
        unableAuthenticate: 'Unable to authenticate you',
        unableToJoinCall: 'Unable to join the call',
        linkExpired: 'Link has expired',
        expiredOn: 'Expired on {date}',
        geolocationFailed:
          'The acquisition of the geolocation information failed. Fill in manually.',
        unknownAuth:
          'The authentication mechanism you are attempting is unknown. Please try again.',
      },

      warnings: {
        disagree:
          'You have disagreed with the terms and conditions and cannot proceed with the conversation. If you would like to change your decision, please refresh the page and try again.',
      },
    },

    labels: {
      cannotSubmitForm: 'The form is already submitted.',
      autoCampaignNotActive: 'Auto Campaign is not active',
      cannotOpenTheForm: 'Cannot open the form in a closed conversation',
      writeReply: 'Write a reply',
      noConversations: 'There are no assigned conversations',
      humansOnly: 'Only with human',
      tac: 'Terms and conditions',
      click: 'Or click',
      here: 'here',
      goBack: 'to go back',
      viewOlder: 'View older conversations',
      pickAddress: 'Pick address',
      currentLocation: 'Current location',
      submitAddress: 'Submit Address',
      streetAddress: 'Street Address',
      zipCode: 'Zip Code',
      fillInTheForm: 'Fill in the form',
      chooseDate: 'Choose a date',
      faq: 'FAQs',
      viewTracker: 'View tracker',
      openSelfScheduler: 'Open {name} Scheduler',
      skipScheduler: 'Skip',
      typeSymptoms: 'Please type your symptoms',
      remoteMicrophoneOff: '{name} has turned off their microphone',
      remoteCameraOff: '{name} has turned off their camera',
      poweredByQliqSoft: 'Powered by QliqSOFT',
    },
    selfScheduler: {
      selectResource: 'Select a resource',
      noSchedulesAvailable: 'No slots available',
      noDefaultChatWidget:
        'No Default Chat Widget Present for this Resource.' +
        ' Please set Default Chat Widget to enable Reminder Workflow.',
      nextButton: 'Next',
      backButton: 'Back',
      insuranceCarrierPlaceholder: 'Insurance Carrier',
      insurancePlanPlaceholder: 'Insurance Plan',
      selectSchedule: 'Select a Schedule',
      noProviders: 'No Providers In Plan',
      seeAllSchedules: 'See all schedules',
      unknownPatient: 'Cannot schedule for unknown patient',
    },
    widgetUnavailable: {
      completeForm: 'Thank you for submitting the form.',
    },

    authentication: {
      privacyReason: 'For privacy reasons, we cannot continue with you now.',
      authenticationRequired: 'Authentication Required',
      authenticationRequested: 'Authentication Requested',
      authenticationReason:
        'For security and privacy, we need you to prove your identity. Please choose a method of proof.',
      continueAsVisitor: {
        linkNotForYou: "If this link wasn't meant for you, you can",
        linkNotForYouLink: 'continue as a visitor.',
        youCan: 'You can',
        otpNotReceived:
          "If you didn't receive the number, or if this link wasn't meant for you, you can",
        otpNotReceivedLink: 'continue as a visitor.',
      },
      pickToAuthenticate: {
        EMAIL: 'via Email',
        MOBILE: 'via Text (SMS)',
        DOB: 'via Date of Birth',
      },
      typeCodeHere: 'Type code here',
      otpSent: 'Authentication code sent',
      enterOtp: {
        EMAIL:
          'Please enter the number you just received via email so that we can verify your identity.',
        MOBILE:
          'Please enter the number you just received via text (SMS) so that we can verify your identity.',
      },
      enterDob: "Please provide the patient's date of birth.",
      goodbye: 'Goodbye!',
      needAuthYou:
        'We need to authenticate you before starting a conversation.',
      enterDobLabel: 'Enter Date of Birth (MM/DD/YYYY)',
      sendCodeTo: 'We will send authentication code to ',
      codeSentTo: 'Authentication code is sent to ',
      changeToEmail: 'Change to Email',
      changeToMobile: 'Change to Text Message',
      authCodeSent: 'Authentication code sent',
      enterAuthCode: 'Enter authentication code',
    },
    quickFormPage: {
      title: 'Attachment',
      failedToLoadForm: 'Failed to load form',
    },
    stopGpt: 'End AI Agent Conversation',
  },
  quickSign: {
    submitError: 'Failed to send Quick Sign Document. Please try again later.',
  },
})
